import React, { useEffect, useState } from "react";
import { NAV } from "@/constants/testIds";
import { LOGO_URL } from "@/content/veguk";
import { Menu, X } from "lucide-react";

const links = [
  { id: "about", label: "About", testid: NAV.linkAbout },
  { id: "types", label: "Types", testid: NAV.linkTypes },
  { id: "exceptions", label: "Exceptions", testid: NAV.linkExceptions },
  { id: "prep", label: "Preparation", testid: NAV.linkPrep },
  { id: "contact", label: "Contact", testid: NAV.linkContact },
];

export const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid={NAV.root}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#F9F6F0]/90 backdrop-blur-md border-b border-[#D1C9B9]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <button
          data-testid={NAV.logo}
          onClick={() => handleNav("hero")}
          className="flex items-center gap-4 group"
          aria-label="VegUK Home"
        >
          <img
            src={LOGO_URL}
            alt="VegUK logo"
            className="h-16 w-16 rounded-full object-contain bg-white border border-[#D1C9B9] p-1.5"
          />
          <div className="hidden sm:flex flex-col leading-tight text-left">
            <span className="font-serif-display text-2xl font-bold text-[#2C352D] tracking-tight">
              VegUK
            </span>
            <span className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#2E5C46]">
              Vegetarian Food Definition
            </span>
          </div>
        </button>

        <ul className="hidden md:flex items-center gap-9">
          {links.map((l) => (
            <li key={l.id}>
              <button
                data-testid={l.testid}
                onClick={() => handleNav(l.id)}
                className="text-base font-semibold text-[#2C352D] hover:text-[#2E5C46] transition-colors"
              >
                {l.label}
              </button>
            </li>
          ))}
        </ul>

        <button
          className="md:hidden p-2 text-[#2C352D]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#D1C9B9] bg-[#F9F6F0]">
          <ul className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <li key={l.id}>
                <button
                  data-testid={`${l.testid}-mobile`}
                  onClick={() => handleNav(l.id)}
                  className="w-full text-left py-2 font-semibold text-[#2C352D] hover:text-[#2E5C46]"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};
